import {NgModule, Optional, SkipSelf} from '@angular/core';
import {ServicesService} from '../lib/rest-service/services.service';
import {ErrorHandlerService} from '../lib/rest-service/error-handler.service';
import {ChartsService} from './charts.service';
import {throwIfAlreadyLoaded} from '../core/module-import-guard';
import {FileManagerService} from "../lib/files-manager/services/file-manager.service";
import {StoreServerManagerService} from "../lib/files-manager/services/store-manager.service";
import {HitfluencerUserService} from "./user/hitfluencer-user.service";
import {HitfluencerUserRestService} from "./user/hitfluencer-user-rest.service";


@NgModule({
  imports: [],
  providers: [
    ServicesService,
    ErrorHandlerService,
    HitfluencerUserService,
    HitfluencerUserRestService,
    ChartsService,
    FileManagerService,
    StoreServerManagerService
  ],
  declarations: [],
  exports: []
})
export class ServicesModule {
  constructor(@Optional() @SkipSelf() parentModule: ServicesModule) {
    throwIfAlreadyLoaded(parentModule, 'CommonModule');
  }
}
